<template>
  <button @click="increase">
    increase
  </button>
</template>


<script>
  import { incrementCounter } from '../vuex/actions.js';
  export default {
    vuex: {
      actions: {
        increase: incrementCounter,
      },
    },
  };
</script>

<style scoped>
  button {
    color: 'red';
  }
</style>



/** WEBPACK FOOTER **
 ** Increase.vue?5ace7a01
 **/